import React from 'react';
import Label from './parts/Label';
import FieldError from './parts/FieldError';
import Description from './parts/Description';
import styled from '@emotion/styled';
import { colors } from '../../../core/styles/theme/default';
import { rem } from 'polished';
import i18n from '../alliance-i18n';

/*

Each field must bring at least:
- id (acts as name etc.)
- label

Optional:
- value
- error
- onChange
- onValidate
- placeholder
- isRequired
- disabled
- prefix
- suffix

*/

const StyledCheckbox = styled.div`
  display: flex;

  input {
    cursor: pointer;
    appearance: none;
    position: relative;
    min-height: 0;
    padding: 0;
    margin: 0;
    height: ${rem(32)};
    width: ${rem(32)};
    flex-shrink: 0;

    &:checked:after {
      content: '✔';
      position: absolute;
      top: ${rem(3)};
      left: ${rem(6)};
      font-size: ${rem(22)};
      color: ${colors.grue800};
    }
  }

  label {
    cursor: pointer;
    margin: ${rem(4)} 0 0 ${rem(16)};
    font-weight: 400;
  }
`;

const Checkbox = ({
  id,
  label,
  locale,
  legend,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  placeholder,
  isRequired,
  isDisabled,
  // isDirty,
  // hasFocus,
  prefix,
  suffix,
  errorRenderer,
}: any) => {
  return (
    <div>
      {legend ? <Label id={id} label={legend} as="legend" /> : null}
      <div>
        {prefix ? <Description top>{prefix}</Description> : null}
        <StyledCheckbox>
          <input
            name={id}
            id={id}
            value="1"
            checked={!!value}
            placeholder={placeholder}
            type={'checkbox'}
            disabled={!!isDisabled}
            aria-required={!!isRequired}
            data-error={!!error}
            onChange={(e) => {
              if (typeof onChange === 'function')
                onChange(e.target.checked ? true : false);
            }}
            onFocus={() => {
              if (typeof onFocus === 'function') onFocus();
            }}
            onBlur={() => {
              if (typeof onBlur === 'function') onBlur();
            }}
          />
          {label ? (
            <Label id={id} label={label} isRequired={isRequired} />
          ) : null}
        </StyledCheckbox>
        {suffix ? (
          <Description small bottom>
            {suffix}
          </Description>
        ) : null}
      </div>
      {error ? (
        errorRenderer ? (
          errorRenderer(error)
        ) : (
          <FieldError text={i18n.errors.requiredField[locale]} />
        )
      ) : null}
    </div>
  );
};

export const isValid = (value: any, config: any) => {
  if (config.isRequired && (value === '' || typeof value === 'undefined'))
    return false;
  return true;
};

export default Checkbox;
